import {tap} from 'rxjs';
import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { HttpClient } from "@angular/common/http";
import {RouterLink} from "@angular/router";
import {HomepageDto} from "../../../dto/homepage/HomepageDto";
import {environment} from "../../../../environments/environment.development";
import {controllersNames} from "../../../controllersNames";
import {SeoService} from "../../../services/seo.service";
import {SettingsService} from "../../../services/settings.service";
import {CoursesService} from "../../../../courses/courses.service";
import {Course} from "../../../interfaces/courses/Course";
import {courseLevelNames} from "../../../enums/courses/CourseLevel";
import {rNames} from "../../../r.names";
import { HomepageBlockItemComponent } from '../include/homepage-block-item/homepage-block-item.component';
import { CardBodyComponent } from '../../../../components/card/card-body/card-body.component';
import { CardHeaderComponent } from '../../../../components/card/card-header/card-header.component';
import { CardComponent } from '../../../../components/card/card/card.component';
import { CardsSkeletonComponent } from '../../../../components/cards-skeleton/cards-skeleton.component';


@Component({
    selector: 'app-homepage',
    templateUrl: './homepage.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CardComponent, CardHeaderComponent, CardBodyComponent, HomepageBlockItemComponent, CardsSkeletonComponent, RouterLink]
})
export class HomepageComponent implements OnInit {
  private http = inject(HttpClient);
  private seo = inject(SeoService);
  private settings = inject(SettingsService);
  private coursesService = inject(CoursesService);

  private readonly cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  dto?: HomepageDto;
  failed = false;
  h1 = environment.siteH1;

  /** курсы на главной — только при включённом разделе (админка) */
  topCourses: Course[] = [];
  lastCourses: Course[] = [];
  imagesPath = environment.imagesPath;
  r = rNames;
  levelNames = courseLevelNames;

  ngOnInit(): void {

    this.seo.setPage({
      title: environment.websiteNameLong,
      path: '/',
    });
    this.seo.setJsonLd([
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: environment.websiteName,
        url: environment.domain + '/',
        logo: environment.domain + '/favicon.png',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: environment.websiteName,
        url: environment.domain + '/',
        inLanguage: 'ru-RU',
      },
    ]);

    if (!this.dto) {
      this.http.get<HomepageDto>(environment.apiBase + '/' + controllersNames.homepage)
        .pipe(takeUntilDestroyed(this.destroyRef), tap({next: () => this.cdr.markForCheck(), error: () => this.cdr.markForCheck(), complete: () => this.cdr.markForCheck()})).subscribe({
          next: value => {
            this.dto = value;
          },
          error: () => this.failed = true
        });
    }

    // раздел курсов выключен в админке → блоков не будет вообще
    this.settings.load().pipe(takeUntilDestroyed(this.destroyRef), tap({next: () => this.cdr.markForCheck(), error: () => this.cdr.markForCheck(), complete: () => this.cdr.markForCheck()})).subscribe({
      next: v => {
        if (v.coursesEnabled) this.loadCourses();
      },
      error: () => {} // настройки недоступны — просто не показываем
    });
  }

  private loadCourses() {
    this.coursesService.getCourseList(1, undefined, undefined, undefined, 'top', 4)
      .pipe(takeUntilDestroyed(this.destroyRef), tap({next: () => this.cdr.markForCheck(), error: () => this.cdr.markForCheck(), complete: () => this.cdr.markForCheck()})).subscribe({next: r => this.topCourses = r.items, error: () => {}});
    this.coursesService.getCourseList(1, undefined, undefined, undefined, 'new', 4)
      .pipe(takeUntilDestroyed(this.destroyRef), tap({next: () => this.cdr.markForCheck(), error: () => this.cdr.markForCheck(), complete: () => this.cdr.markForCheck()})).subscribe({next: r => this.lastCourses = r.items, error: () => {}});
  }


}
